export default __webpack_public_path__ + "static/media/galleryimage.f17d50d8.svg";